<style lang="scss">
#date-picker {
  .v-input {
    input {
      padding: 6px 0 5px 30px;
      max-height: 40px;
    }
  }
  .date-picker__icon {
    position: absolute;
    top: 15px;
    left: 11px;
  }
}
</style>
<template>
  <v-layout wrap id="date-picker">
    <v-flex class="relative">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :format="formatDate"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            class="pt-0"
            :class="error"
            v-model="dateFormatted"
            @blur="date = parseDate(dateFormatted)"
            :label="title"
            readonly
            v-on="on"
            :error="error"
            :disabled="disabled"
            outlined
            @click="changeData()"
            dense
            :placeholder="placeholder"
          ></v-text-field>
          <v-icon class="date-picker__icon">event</v-icon>
        </template>
        <v-date-picker
          v-model="date"
          :min="min"
          :max="max"
          @input="menu = false;"
          :locale="lang"
          :type="type"
          :format="format"
          :disabled-dates="disabledDates"
          :weekday-format="getDay"
          :header-date-format="formatHeaderDate"
          :title-date-format="titleDateFormat"
        ></v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    title: String,
    model: String,
    error: Boolean,
    disabled: Boolean,
    min: String,
    max: String,
    type: String,
    format: String,
    disabledDates: Array,
    placeholder: String
  },
  data() {
    return {
      date: null,
      dateFormatted: null,
      menu: false,
      lang: this.$i18n.locale,
      dateFormat: this.format,
      locale: {
        daysShort: [
          this.$t("DAYS_OF_WEEK.SUN"), 
          this.$t("DAYS_OF_WEEK.MON"), 
          this.$t("DAYS_OF_WEEK.TUE"), 
          this.$t("DAYS_OF_WEEK.WED"), 
          this.$t("DAYS_OF_WEEK.THU"), 
          this.$t("DAYS_OF_WEEK.FRI"), 
          this.$t("DAYS_OF_WEEK.SAT"),
        ],
        months: [
            this.$t("_DATE_RANGE.JAN"), 
            this.$t("_DATE_RANGE.FEB"),
            this.$t("_DATE_RANGE.MAR"),
            this.$t("_DATE_RANGE.APR"),
            this.$t("_DATE_RANGE.MAY"),
            this.$t("_DATE_RANGE.JUN"),
            this.$t("_DATE_RANGE.JUL"),
            this.$t("_DATE_RANGE.AUG"),
            this.$t("_DATE_RANGE.SEP"),
            this.$t("_DATE_RANGE.OTC"),
            this.$t("_DATE_RANGE.NOV"),
            this.$t("_DATE_RANGE.DEC")
          ],
      },
    };
  },
  created() {
    this.date = this.model;
  },
  watch: {
    model(value) {
      this.date = value;
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.$emit("update:error", false);
      this.$emit("update:model", this.date);
    },
    // disabled() {
    //   this.reset();
    // }
  },
  methods: {
    getDay(date){
      const d = new Date(date);
      if (!['lo', 'km'].includes(this.lang)) {
        let day = new Intl.DateTimeFormat(this.lang, { weekday: 'short' }).format(d);
        if (this.lang === 'vi') {
          day = day.replace(/^Th\s?/, 'T');
        }
        return day;
      };
      let i = new Date(date).getDay(date)
      return this.locale.daysShort[i];
    },
    formatHeaderDate(date) {
      const d = new Date(date);
      if (!['lo', 'km'].includes(this.lang)) {
        return new Intl.DateTimeFormat(this.lang, {
          month: 'long',
          year: 'numeric'
        }).format(d);
      }
      const month = d.getMonth();
      const year = d.getFullYear();
      return `${this.locale.months[month]} ${year}`;
    },
    titleDateFormat(date) {
      const d = new Date(date);
      if (!['lo', 'km'].includes(this.lang)) {
        return new Intl.DateTimeFormat(this.lang, {
          weekday: 'short',
          day: 'numeric',
          month: 'long'
        }).format(d);
      };
      const day = d.getDay();
      const dateNum = d.getDate();
      const month = d.getMonth();
      const year = d.getFullYear();
      return `${this.locale.daysShort[day]}, ${dateNum} ${this.locale.months[month]}`;
    },
    reset() {
      this.date = null;
      this.$emit("update:error", false);
      this.$emit("update:model", this.date);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      if( this.type && this.type == 'month' ){
      return `${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    },
    parseDate(date) {
      if (!date) return null;
      
      if( this.type && this.type == 'month' ){
      const [month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}`;
      } else {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
    changeData() {
      this.$emit("changeData");
    }
  }
};
</script>
